import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { BodyLarge, ButtonOutlineLarge, H3 } from '@styled';

const OuterWrapper = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 40px;
`;

const InnerWrapper = styled.div`
    max-width: 100%;
    width: 796px;
`;

const CTAButton = styled(ButtonOutlineLarge)`
    &:not(:last-child) {
        margin-right: 30px;
    }
`;

const EventAgendaEmpty = ({ onSessionsClick, onAvailabilityClick, onMatchesClick }) => (
    <OuterWrapper>
        <InnerWrapper>
            <H3 className="mb-3 text-center">Your agenda for the day is empty.</H3>
            <BodyLarge className="text-center" style={{ marginBottom: '40px' }}>
                Start saving sessions you’re interested in and scheduling meetings with other attendees to start
                building out your event agenda.
            </BodyLarge>

            <div className="d-flex justify-content-center">
                <CTAButton onClick={onSessionsClick}>Explore Sessions</CTAButton>
                {/* <CTAButton onClick={onAvailabilityClick}>Set Your Availability</CTAButton> */}
                <CTAButton onClick={onMatchesClick}>Explore Your Matches</CTAButton>
            </div>
        </InnerWrapper>
    </OuterWrapper>
);

EventAgendaEmpty.propTypes = {
    onSessionsClick: PropTypes.func.isRequired,
    onAvailabilityClick: PropTypes.func.isRequired,
    onMatchesClick: PropTypes.func.isRequired,
};

export default EventAgendaEmpty;
